import { request, requestBanling } from './request'

//帖子列表
export function getPics(page) {
  return request({
    url: '/topics',
    method: "get",
    params: {
      page
    }
  })
}
//关注的帖子列表
export function getFollowingTopics(page) {
  return request({
    url: '/following_topics',
    method: "get",
    params: {
      page
    }
  })
}
//活动的帖子列表
export function getActivityTopics(page) {
  return request({
    url: '/activity_topics',
    method: "get",
    params: {
      page
    }
  })
}
//帖子详情
export function getForums(id, inviter_id) {
  if (inviter_id) {
    return request({
      url: '/topics/' + id + '?inviter_id=' + inviter_id,
      method: "get",
    })
  } else {
    //如果没有邀请人id，则不传
    return request({
      url: '/topics/' + id,
      method: "get",
    })
  }

}
//关注
export function userFollow(data) {
  return request({
    url: '/follow',
    method: "post",
    data
  })
}
//取消关注
export function userUnFollow(data) {
  return request({
    url: '/unfollow',
    method: "post",
    data
  })
}
//点赞帖子
export function likeTopic(data) {
  return request({
    url: '/like_topic',
    method: "post",
    data
  })
}
//取消点赞帖子
export function unLikeTopic(data) {
  return request({
    url: '/unlike_topic',
    method: "post",
    data
  })
}
//收藏帖子
export function favoriteTopic(data) {
  return request({
    url: '/favorite_topic',
    method: "post",
    data
  })
}
//取消收藏帖子
export function unFavoriteTopic(data) {
  return request({
    url: '/unfavorite_topic',
    method: "post",
    data
  })
}
//发送评论
export function sendReplies(data) {
  return request({
    url: '/replies',
    method: "post",
    data
  })
}
//回帖列表
export function getReplies(params) {
  return request({
    url: '/replies',
    method: "get",
    params
  })
}
//点赞回帖
export function like_reply(data) {
  return request({
    url: '/like_reply',
    method: "post",
    data
  })
}
//取消点赞回帖
export function unlike_reply(data) {
  return request({
    url: '/unlike_reply',
    method: "post",
    data
  })
}
//删除评论
export function delete_reply(id) {
  return request({
    url: '/replies/' + id,
    method: "delete",
  })
}
//活动详情
export function eventid_detail(event_id) {
  return request({
    url: '/events/' + event_id,
    method: "get",
  })
}
//活动详情
export function applay_eventid(data) {
  return request({
    url: '/events/apply',
    method: "post",
    data
  })
}
//获取微信分享签名等信息
export function getWXInfo(url) {
  return requestBanling({
    url: '/weixin/?appid=wx760d1fef4674d0c4&act=jsSDK&url=' + encodeURIComponent(url),
    method: "get",
  })
}
//平台规则已读
export function agreeTosRead(data) {
  return request({
    url: '/tos_read',
    method: "post",
    data
  })
}
// 321活动添加积分
export function event_qb321_add_score(params) {
  return request({
    url: 'https://kpc.cowsms.com/event_qb321_add_score',
    method: 'get',
    params,
  })
}
export function gift(params) {
  return request({
    url: 'https://qb321.bjszhd.cn/api/open_prize/gift',
    method: 'get',
    params,
  })
}
export function setUserGift(params) {
  return request({
    url: 'https://qb321.bjszhd.cn/api/open_prize/setUserGift',
    method: 'get',
    params,
  })
}
